import type { ReactNode } from 'react';

export const symbol_text_rotation_angleup: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M781-498 396-113q-9 9-21 9t-21-9q-9-9-9-21t9-21l385-385h-48q-13 0-21.5-8.5T661-570q0-13 8.5-21.5T691-600h120q13 0 21.5 8.5T841-570v120q0 13-8.5 21.5T811-420q-13 0-21.5-8.5T781-450v-48Zm-467 12 47 99q4 8 2 15.5t-7 13.5q-10 10-23.5 7.5T313-366L143-743q-4-8-2.5-16t7.5-14l14-14q6-6 14-7.5t16 2.5l378 171q12 5 14.5 18.5T577-579q-6 6-13.5 7.5T548-574l-98-46-136 134Zm-22-44 114-112-210-99-3 2 99 209Z"
		/>
	</svg>
);
